import { useEffect } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { HOME, NEWS } from "../../../constants/routes";
import CustomBreadcrumb from "../../moleculas/CustomBreadcrumb";
import ErrorMessage from "../../moleculas/ErrorMessage";
import Loader from "../../moleculas/Loader";
import NewsDetailContent from "../../organims/News/NewsDetailContent";
import { useNewsDetail } from "./useNewsDetail";

const NewsDetail = () => {
  const { t } = useTranslation("news");
  const { loading, error, notFound, noticia, retry } = useNewsDetail();

  useEffect(() => {
    document.title = `SINIA - ${noticia?.title || t("title")}`;
  }, [noticia, t]);

  return (
    <div className="w-100 d-flex justify-content-md-start justify-content-lg-start flex-column">
      <div className="w-100 d-flex flex-column align-items-center">
        <div className="w-75 align-items-left breadcrumb-height">
          <CustomBreadcrumb
            isWhite={false}
            breadcrumbs={[
              { name: t("home"), href: HOME },
              { name: t("title"), href: NEWS },
              ...(noticia ? [{ name: noticia.title }] : []),
            ]}
          />
        </div>

        <div className="w-75 mb-5 align-items-left">
          {loading ? <Loader /> : null}

          {!loading && error ? (
            <div className="d-flex flex-column align-items-center gap-3">
              <ErrorMessage message={error} />
              {notFound ? (
                <Link className="btn custom-primary-button" to={NEWS}>
                  {t("backToList")}
                </Link>
              ) : (
                <Button onClick={retry} className="custom-primary-button">
                  {t("retry")}
                </Button>
              )}
            </div>
          ) : null}

          {!loading && !error && noticia ? (
            <>
              <NewsDetailContent noticia={noticia} />
              <Link className="btn custom-primary-button" to={NEWS}>
                {t("backToList")}
              </Link>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default NewsDetail;
